import { createSelector } from 'reselect'

import { Firebase } from '../../Core'

import * as utils from './events.util'

export const getStorylineEvents = (state) => state.storyLine.events
export const getEventsState = (state) => state.mars.events

export const getCurrentEvent = createSelector(
  [
    getStorylineEvents,
    Firebase.selectors.getUserMap,
    Firebase.selectors.getPlayerData,
    Firebase.selectors.getGroupData,
  ],
  (events, userMap, userData, groupData) => {
    const buildings = userMap.buildings
    const executableEvents = Object.keys(events)
      .map((eventId) => events[eventId])
      .filter((event) => {
        const findedBuilding = Object.keys(buildings).find(
          (buildingId) => event.required == buildings[buildingId].name
        )
        if (
          ((userData.settlers == 0 || !findedBuilding) && event.required) ||
          (groupData.session == 1 &&
            event.type == 'negative' &&
            event.effect &&
            event.effect.action == 'coins')
        ) {
          return null
        }
        return event
      })
    return utils.getExecutableEvent(executableEvents)
  }
)
export const getExecutedEvent = createSelector([getEventsState], (events) => events.executedEvent)
